import { render, staticRenderFns } from "./newsInfo.vue?vue&type=template&id=fa9d567e&scoped=true&"
import script from "./newsInfo.vue?vue&type=script&lang=js&"
export * from "./newsInfo.vue?vue&type=script&lang=js&"
import style0 from "./newsInfo.vue?vue&type=style&index=0&id=fa9d567e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9d567e",
  null
  
)

export default component.exports